import { createAction } from '@reduxjs/toolkit';
import { Modal } from '../../types/ModalTypes/Modal';

export const ADD_MODAL = 'ADD_MODAL';

export const addModal = createAction(
    ADD_MODAL,
    (modal: Modal) => ({ payload: { ...modal } }),
);
